import type { ReactNode } from 'react';
import { Plus } from 'lucide-react';
import { AssetMarketplace } from '../../../components/marketplace';
import type { MarketplaceAsset } from '../../../types/marketplace';

export interface McpPanelProps {
  assets: MarketplaceAsset[];
  /** 添加 / 移除 MCP 服务。 */
  onToggle: (asset: MarketplaceAsset) => void;
  /** 点击编辑：页面按 id 找到 MCP Server 并打开编辑器。 */
  onEdit: (asset: MarketplaceAsset) => void;
  /** 新增 MCP 服务。 */
  onAdd: () => void;
  /** MCP 在线服务工具栏节点。 */
  toolbar: ReactNode;
}

/** MCP 工具维度面板：MCP 工具橱窗（添加 / 移除 / 新增编辑）。 */
export default function McpPanel({ assets, onToggle, onEdit, onAdd, toolbar }: McpPanelProps) {
  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        <h3 style={{ margin: 0 }}>MCP 工具橱窗</h3>
        <button className="primary" style={{ padding: '6px 12px', fontSize: 13 }} onClick={onAdd}>
          <Plus size={14} /> 新增 MCP
        </button>
      </div>
      {toolbar}
      <AssetMarketplace
        assets={assets}
        initialType="mcp"
        hideTypeFilter
        title=""
        applyLabel="添加"
        removeLabel="移除"
        onToggle={onToggle}
        onEdit={onEdit}
      />
    </div>
  );
}
